<template>
    <div>
        <div class="w-app">
            <div id="application-wrapper">

                <TopBarDesktop/>

                <div class="content-wrapper search-menu">
                    <vue-custom-scrollbar id="js-clubs-content" ref="vueCustomScrollbar" class="col calendar-list">
                        <div class="center">
                            <div class="tabs calendar-tabs">
                                <div :class="{'tab':true, 'active': type === typeItem}"
                                    v-for="typeItem in types"
                                    @click="setType(typeItem, $event)">
                                    <span :class="{'notificated-bang':(typeItem === 'my_clubs' && (userHasClubNotifications) && type !== typeItem)}">{{ trans(`clubs.type.${typeItem}`) }}</span>
                                </div>
                            </div>

                            <div class="tab-content-wrapper calendar-tabs" :class="{[type]: true}">
                                <div class="tab-content-inner">
                                    <div class="tab-content">
                                        <div class="clubs">

                                            <InnerList/>

                                        </div>

                                        <div id="add-club" class="add-event-button"
                                            @click="createClub('club')" :title="trans('create_club')">
                                            {{ trans('create_club') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vue-custom-scrollbar>
                </div>
                <HideChats />
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.notificated-bang {
  &:before {
    content: "";
    position: absolute;
    top: 15px;
    margin-left:-13px;
    z-index: 1;
    width: 10px;
    height: 10px;
    border-radius: 2px;
    background: #FF0000;
  }
}
</style>

<script>
    import InfiniteLoading from 'vue-infinite-loading';
    import {mapState, mapActions, mapGetters} from 'vuex';

    import TopBarDesktop from '@buddy/views/widgets/TopBarDesktop.vue';
    import InnerList from '@clubs/views/widgets/InnerList.vue';
    // import HealthAlert from '@buddy/views/widgets/HealthAlert.vue';

    import clubsModule from '@clubs/module/store/type'
    import HideChats from "@buddy/views/widgets/HideChats.vue";

    // custom scrollbar
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"

    export default {
        mixins: [
            require('@general/lib/mixin').default,
            require('@general/lib/mixin-clubs').default,
        ],
        data() {
            return {
                types: [
                    'discover',
                    'my_clubs',
                ],
            }
        },
        computed: {
            ...mapState({
                myClubs: 'myClubs',
                userIsPro: 'userIsPro',
                profile: 'profile'
            }),
            ...mapGetters({
                type: clubsModule.getters.type,
                clubDates: clubsModule.getters.clubDates,
                getInvitationsToClub:'getInvitationsToClub',
                userHasClubNotifications: 'userHasClubNotifications',
            }),
        },
        components: {
            InfiniteLoading,
            TopBarDesktop,
            InnerList,
            HideChats,
            vueCustomScrollbar
            // HealthAlert
        },
        methods: {
            ...mapActions({
                requirementsAlertShow: 'requirementsAlertShow',
                setBang: clubsModule.actions.setBang,

            }),
            setType(type, e) {
                if(this.showJoinModalIfNeed(e)){
                  return false;
                }
                console.log('[Events List] setType')
                this.$store.dispatch(clubsModule.actions.setType, type)

                this.$store.dispatch(clubsModule.actions.setClub, { visible: false });

                app.$emit('reload-clubs')
                // this.$store.dispatch('showHealthAlert')
            },
            createClub(type) {
              if(this.showJoinModalIfNeed()){
                return false;
              }
                if (!this.userIsPro && this.myClubs && this.myClubs.length >= window.FREE_CLUBS_LIMIT) {
                    this.requirementsAlertShow('clubs')
                } else {
                    let payload = { visible: true, mode: 'create' }
                    this.setClub(payload)
                }
            }
        },
        mounted() {
            console.log('[Events] Mounted')
            let clubId = this.$route.query.clubId
            if (clubId) {
                this.openEvent(clubId, 'club')
            }

            this.loadScrollTopButton('js-clubs-content');
            store.dispatch('showAdminPopUp','clubs')
        },
        deactivated() {
            console.log('[Events] Destroyed')
            this.$store.dispatch(clubsModule.actions.setClub, { visible: false });
            app.$off('reload-clubs', this.resetClubsAround)
        },
        watch: {
          clubDates() {
              this.$refs.vueCustomScrollbar.$forceUpdate()
          }
        }
    }
</script>
